import { combineReducers } from 'redux'
import { persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage'
// slices

import allGuaranteesReducer from './slices/all-guarantees'
import notificationsReducer from './slices/notifications'
import legalEntitiesReducer from './slices/legalEntities'
import termsReducer from './slices/terms'
import userReducer from './slices/user'
import pdfReducer from './slices/pdf'
import contractPdfReducer from './slices/contractPdf'
import legalsReducer from './slices/legals'

import createGuaranteeReducer from './slices/create-guarantee-request'
import setGuaranteeRequestPayloadReducer from './slices/create-payload'
import contractHistoryReducer from './slices/contract-history'
import sponsoredEntityReducer from './slices/sponsored-private-entity'
import purposeTypesReducer from './slices/purposeTypes'
import socketConnectReducer from './slices/socket-auth-status'
import networkReducer from './slices/socket-auth-status'
import getErrorReducer from './slices/createError'
import adminCreateActionsReducer from './slices/admin-create-actions'
import adminUsersReducer from './slices/admin-users'
import adminRolesReducer from './slices/admin-roles'
import adminTeamsReducer from './slices/admin-org-details'
import adminLeReducer from './slices/admin-le'
import socketHealthReducer from './slices/socket-health'

// ----------------------------------------------------------------------

const rootPersistConfig = {
  key: 'root',
  storage,
  keyPrefix: 'redux-'
}

const gxPersistConfig = {
  key: 'guarantee',
  storage,
  keyPrefix: 'redux-'
}

const gxCreateActionsConfig = {
  key: 'admin',
  storage,
  keyPrefix: 'redux-'
}

const gxAdminRoles = {
  key: 'admin-roles',
  storage,
  keyPrefix: 'redux-'
}

const gxAdminOrgUnits = {
  key: 'admin-orgs',
  storage,
  keyPrefix: 'redux-'
}

const userPersistConfig = {
  key: 'user',
  storage,
  keyPrefix: 'redux-'
}

const createGxPersistConfig = {
  key: 'createGx',
  storage,
  keyPrefix: 'redux-'
}


const rootReducer = combineReducers({
  createGuarantee: createGuaranteeReducer,
  socketAuthStatus: socketConnectReducer,
  createGuaranteePayload: setGuaranteeRequestPayloadReducer,
  allGuarantees: allGuaranteesReducer,
  notifications: notificationsReducer,
  contractHistory: contractHistoryReducer,
  legalEntities: legalEntitiesReducer,
  termsReducer: termsReducer,
  purposeTypes: purposeTypesReducer,
  network: networkReducer,
  createError: getErrorReducer,
  sponsoredEntity: sponsoredEntityReducer,
  userReducer: userReducer,
  pdfReducer: pdfReducer,
  contractPdfReducer: contractPdfReducer,
  legals: legalsReducer,
  adminCreateActions: adminCreateActionsReducer,
  adminUsers: adminUsersReducer,
  adminRoles: adminRolesReducer,
  adminOrgUnits: adminTeamsReducer,
  adminLeEntities: adminLeReducer,
  socketHealth: socketHealthReducer
})

export { rootPersistConfig, rootReducer }
